/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Automation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import AppointmentType from './AppointmentType/index'
import AutomationType from './AutomationType/index'
import BackAction from './BackAction/index'
import CancelAction from './CancelAction/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import EventActions from './EventActions/index'
import EventType from './EventType/index'
import Location from './Location/index'
import Name from './Name/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import SectionTitle from './SectionTitle/index'
import TriggerType from './TriggerType/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Automation({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentAutomations/Automation"
  
}) {
let tabSelectedEventIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.event_id',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let tabSelectedEventIdValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.event_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let tabSelectedEventTypeValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.event_type',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let tabSelectedAppointmentTypeIdsValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.appointment_type_ids',
format: fromFormat.isNotEmptyList,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.selected.event_id"
 eventId={tabSelectedEventIdValueData}
/>
<div
  data-testid="Automation.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z2jmc2o': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-2-Z2jmc2o': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-3-Z2jmc2o': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pb-4-Z2jmc2o': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text={tabSelectedEventIdValueData1 ? "Edit Automation" : "Add new Automation"}
 marginTop={dtSpaceXs}
 level="h2"
 data="tab.selected.event_id"
/>
<div
  data-testid="Automation.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Enhance your workflow management with the Greyfinch Automation Hub. Automations can be based on treatment status or appointment status changes."
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 marginLeft={dtSpaceXxs}
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
 text="Learn how this works."
 goTo="https://support.greyfinch.com/hc/en-us/articles/24002245316621-Automation-Hub"
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceL}
/>
<div
  data-testid="Automation.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Location
  viewPath={`${viewPath}/Location`}
/>
<Name
  viewPath={`${viewPath}/Name`}
/>
<AutomationType
  viewPath={`${viewPath}/AutomationType`}
/>
<EventType
  viewPath={`${viewPath}/EventType`}
/>
</div>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 width="100%"
 flexDirection="column"
 marginTop={dtSpaceM}
 borderColor={tabSelectedEventTypeValueData ? dtColorsNeutral200 : "transparent"}
 data="tab.selected.event_type"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={dtSpaceM}
>
{childProps => (
<React.Fragment>
<SectionTitle
{...childProps}
  viewPath={`${viewPath}/SectionTitle`}
/>
<AppointmentType
{...childProps}
  viewPath={`${viewPath}/AppointmentType`}
/>
<div
  data-testid="Automation.Vertical:2"
  data-view-path={viewPath}
 style={{'--bblr-5-Z2jmc2o': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z2jmc2o': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-7-Z2jmc2o': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-8-Z2jmc2o': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-9-Z2jmc2o': dtColorsWhite,'--pt-3-Z2jmc2o': !tabSelectedAppointmentTypeIdsValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-4-Z2jmc2o': !tabSelectedAppointmentTypeIdsValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z2jmc2o': !tabSelectedAppointmentTypeIdsValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-1-Z2jmc2o': !tabSelectedAppointmentTypeIdsValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-10-Z2jmc2o': !tabSelectedAppointmentTypeIdsValueData ? "transparent" : dtColorsNeutral200,'--bw-11-Z2jmc2o': !tabSelectedAppointmentTypeIdsValueData ? "0px" : "1px"}}
 className={`views-block ${styles.Vertical2}`}
>
<TriggerType
  viewPath={`${viewPath}/TriggerType`}
/>
<EventActions
  viewPath={`${viewPath}/EventActions`}
/>
</div>
</React.Fragment>
)}
</TysiaCardContent>
)}
</TysiaCard>
<div
  data-testid="Automation.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-12-Z2jmc2o': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal1}`}
>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}